import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import useGenre from 'pages/AIMusicGenerator/useGenre';
import {
  FormulaFields,
  type GenreBlend,
  type AdvancedBundle as IAdvancedBundle,
} from 'services/store/ai/types';
import FormulaTags from '../../FormulaTags';
import ShareFormulaButton from '../../ShareFormulaButton';
import BundleImages from '../BundleImages';
import BundleSongs from '../BundleSongs/BundleSongs';
import {
  StyledBundleActionSkeleton,
  StyledBundleActions,
  StyledBundleContainer,
  StyledBundleHead,
  StyledBundleInfo,
  StyledBundleTitle,
} from '../styled';

interface AdvancedBundleProps {
  bundle: IAdvancedBundle;
}

const AdvancedBundle = ({ bundle }: AdvancedBundleProps) => {
  const [ref, inViewport] = useInView();

  const { t } = useTranslation();

  const { genre, formula } = bundle;
  const genreData = useGenre(genre);
  const genreImage = genreData?.imageUrl;

  const genreBlend =
    formula.find(
      (item): item is GenreBlend => item.field === FormulaFields.GenreBlend
    )?.value || null;
  const genreBlendData = useGenre(genreBlend);
  const genreBlendImage = genreBlendData?.imageUrl;

  const genreImages = [genreImage, genreBlendImage];

  return (
    <StyledBundleContainer ref={ref}>
      <StyledBundleHead>
        <BundleImages isLoading={!inViewport} images={genreImages} />
        <StyledBundleInfo>
          <StyledBundleTitle>
            {genre}
            {genreBlend &&
              ` X ${t('aiMusicGenerator:tagLabels:blend', { genreBlend })}`}
          </StyledBundleTitle>
          <FormulaTags bundle={bundle} />
          <StyledBundleActions>
            {inViewport ? (
              <ShareFormulaButton bundle={bundle} />
            ) : (
              <StyledBundleActionSkeleton />
            )}
          </StyledBundleActions>
        </StyledBundleInfo>
      </StyledBundleHead>

      <BundleSongs bundle={bundle} isLoading={!inViewport} />
    </StyledBundleContainer>
  );
};

export default AdvancedBundle;
